import React from 'react';
import DarkMarketingPage from '../Shared/DarkMarketingPage';

const sections = [
  {
    label: 'ORCHESTRATION',
    title: 'Plan and ship campaigns with connected MCPs',
    description:
      'Coordinate your product launches, landing page updates, and promotional pushes from one shared workflow. EditPage MCPs keep your website, storefront, and traffic operations aligned so launches feel fast and consistent.',
    link: '/agentic-commerce',
  },
  {
    label: 'EXECUTION',
    title: 'Move from idea to live storefront in fewer steps',
    description:
      'Use Website, Store, Domain, and Email MCPs together to turn briefs into live experiences. Teams can update offers, highlight products, and publish messaging without juggling disconnected tools.',
    link: '/agentic-commerce',
    reverse: true,
  },
  {
    label: 'OPTIMIZATION',
    title: 'Improve conversion with continuous feedback loops',
    description:
      'Traffic and Analytics MCPs bring signal back into the workflow so you can refine pages, adjust campaigns, and iterate on conversion paths week over week.',
    link: '/agentic-commerce',
  },
];

const quickTags = [
  'Website MCP',
  'Store MCP',
  'Domain MCP',
  'Email MCP',
  'Traffic MCP',
  'Analytics MCP',
];

const AgenticCommerceContent = ({ history }) => (
  <DarkMarketingPage
    history={history}
    title="Agentic Commerce for Modern Teams"
    subtitle="EditPage helps your team orchestrate high-velocity commerce workflows with connected MCPs across content, storefront, and growth systems."
    sections={sections}
    quickTags={quickTags}
  />
);

export default AgenticCommerceContent;
